import { render, staticRenderFns } from "./staff-list.vue?vue&type=template&id=c03fb982&scoped=true"
import script from "./staff-list.vue?vue&type=script&lang=js"
export * from "./staff-list.vue?vue&type=script&lang=js"
import style0 from "./staff-list.vue?vue&type=style&index=0&id=c03fb982&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03fb982",
  null
  
)

export default component.exports